import React, { ReactNode } from 'react';
import { H3 } from '../../primitives';
import Spacer from '../../helpers/Spacer';
import styled from '@emotion/styled';
import { colors, mixins } from '../../core/styles/theme/default';

const StyledFact = styled.article`
  flex-direction: column;
  display: flex;

  ${mixins.responsiveStyles({
    height: { zero: 'auto', medium: '100%' },
  })}

  header {
    display: flex;
    align-items: flex-end;
  }

  ${({ theme }) => theme?.stylesExtension?.fact?.fact}
`;

const StyledFactMain = styled.div`
  flex: 1;
`;

const StyledTitle = styled(H3)`
  color: ${colors.primary};
  padding-right: 2rem;
`;

const StyledLink = styled.a`
  font-size: 0.875rem;
  color: ${colors.grey600};
  text-decoration: none;
  transition: color 0.3s ease, transform 0.3s ease;

  &:hover {
    color: ${colors.grey700};
    transform: translateY(-2px);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);
  }
`;

const Fact = (props: FactProps) => {
  const { highlight, richtext, source } = props.data;

  return (
    <>
      <StyledFact className={'fact'}>
        <header>
          <StyledTitle>{highlight}</StyledTitle>
        </header>
        <Spacer space="gamma" />
        <StyledFactMain>{richtext}</StyledFactMain>
        <Spacer space="alpha" />
        {source ? (
          <StyledLink
            href={source.url}
            title={source.linkText}
            target="_blank"
            rel="noopener noreferrer"
          >
            {source.linkText}
          </StyledLink>
        ) : null}
      </StyledFact>
    </>
  );
};

export type FactProps = {
  data: {
    highlight: string;
    richtext: ReactNode;
    source?: {
      linkText: string;
      url: string;
    };
  };
};

export default Fact;
